import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext(null);
const { Consumer } = Context;

class Provider extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			expanded : props.initiallyExpanded,
		};
	}

	onToggle = () => this.setState((prevState) => ({ expanded : !prevState.expanded }));

	render() {
		const { children } = this.props;

		return (
			<Context.Provider
				value={{
					...this.state,
					onToggle : this.onToggle,
				}}
			>
				{ children }
			</Context.Provider>
		);
	}
}

Provider.propTypes = {
	initiallyExpanded : PropTypes.bool,
	children          : PropTypes.any,
};

Provider.defaultProps = {
	initiallyExpanded : false,
	children          : null,
};

export default {
	Provider,
	Consumer,
};
